import jwtDecode from 'jwt-decode';

const ONE_MILISECOND = 1000;

function decodeJwt(jwt) {
  return jwtDecode(jwt);
}

function isTokenExpired(jwt) {
  if (!jwt) {
    return true
  }

  const expireDate = decodeJwt(jwt)?.exp
  return (expireDate * ONE_MILISECOND) < Date.now()
}

export {
  decodeJwt,
  isTokenExpired,
};
